



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Bowser from "bowser";

@Component
export default class Browsercheck extends Vue {

    browser = Bowser.getParser(window.navigator.userAgent);

    get browserIsSupported() {

        const isInvalidBrowser = this.browser.satisfies({
             // or in general
            ie: "<=12",
            safari: "<11",
            firefox: "<34",
            chrome: "<37",
            mobile: {
                'safari': '<11',
                'android browser': '<5',
            },
        });

        this.$log.info("Invalid Browser detected:", isInvalidBrowser);
        return !isInvalidBrowser;
    }

    get isWindows() {
       const os = this.browser.getOS();
       return os.name === "Windows";
    }

    get isMac() {
        const os = this.browser.getOS();
        return os.name === "macOS";
    }
}
